import CustomBreadcrumbs from '@/commons/custom-breadcrumbs';
import { PATH_DASHBOARD } from '@/routes/paths';
import { translates } from '@/utils';
import { Button, Chip, Container, Grid } from '@mui/material';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import React, { createElement, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import {
  changeTipsFactureService,
  discountOrderService,
  putFacturePayService,
  rePrinterFactureService,
} from '@/services';
import { Iconic } from '@commons/iconic';
import { useOrderId } from '@/hooks/useOrderId';
import { TITLE } from '@/utils/constants';
import CheckoutPaymentForm from '../form/checkout';
import { GeneralDiscount } from '../components/modals/generalDiscount';
import { useFetch } from '../hooks/useFetch';
import { GenerateElectornicBill } from '../components/bill-electronic';

export default function OrderCheckoutPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const currentId = id ?? '';
  const {
    invalidateByCheckout,
    invoices,
    invoicesWhitOutFormat,
    billingInfo,
    dataOrder,
    invoicesResult : dataInvoices,
    reload
  } = useOrderId(currentId);
  const { fetchProperties: onSubmitFacturePay } = useFetch({ fetchFunction: putFacturePayService });
  const { fetchProperties: onSubmitChangeTipsFactureService } = useFetch({
    fetchFunction: changeTipsFactureService,
  });
  const { fetchId: onSubmitRePrinterFactureService } = useFetch({
    fetchFunction: rePrinterFactureService,
  });



  const onSaveFacturePay = async (values: any) => {
    try {
      await onSubmitFacturePay(currentId, values);
      navigate(PATH_DASHBOARD.orders.view(currentId), { replace: true });
      invalidateByCheckout();
    } catch (error) {
      console.log('🚀 ~ file: checkout.tsx:45 ~ onSaveFacturePay ~ error:', error.error.message);
    }
  };

  const onSaveDiscountOrderService = async (values: any) => {
    try {
      await discountOrderService(currentId, values.percentage);
      // navigate(PATH_DASHBOARD.orders.view(currentId), { replace: true });
      await reload()

    } catch (error) {
      console.log('🚀 ~ file: checkout.tsx:45 ~ onSaveFacturePay ~ error:', error.error.message);
    }
  };

  const onSaveChangeTipsFactureService = async (values: any) => {
    try {
      await onSubmitChangeTipsFactureService(currentId, values);
      await reload()
    } catch (error) {
      console.log('🚀 ~ file: checkout.tsx:45 ~ onSaveFacturePay ~ error:', error.error.message);
    }
  };

  const onSaveRePrinterFactureService = async (values: any) => {
    try {
      await onSubmitRePrinterFactureService(currentId);
    } catch (error) {
      console.log('🚀 ~ file: checkout.tsx:45 ~ onSaveFacturePay ~ error:', error.error.message);
    }
  };

  const completed = false;

  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const Component = useMemo(
    () =>
      createElement(GeneralDiscount, {
        open,
        onClose: handleClose,
        invoices: invoicesWhitOutFormat,
        selectedValue: '',
        onSave: onSaveDiscountOrderService,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [invoicesWhitOutFormat, open]
  );


  return (
    <>
      <Helmet>
        <title> {TITLE}: Checkout </title>
      </Helmet>

      <Container maxWidth="lg">
        <CustomBreadcrumbs
          heading={translates.checkout}
          links={[
            { name: translates.dashboard, href: PATH_DASHBOARD.root },
            {
              name: translates.orders,
              href: PATH_DASHBOARD.orders.root,
            },
            {
              name: dataOrder?.table ?? dataOrder?.currentId,
              href: PATH_DASHBOARD.orders.view(currentId),
            },
            { name: translates.checkout },
          ]}
          action={[
            <>
              <Chip onClick={handleClickOpen} color="info" label={translates.orderDiscount} />
              {id && (
                <Button
                  onClick={onSaveRePrinterFactureService}
                  color="warning"
                  startIcon={<Iconic icon="mdi:printer" />}
                >
                  {translates.printInvoice}
                </Button>
              )}
              <GenerateElectornicBill orderId={currentId} />

            </>,
          ]}
        />

        <Grid container justifyContent={completed ? 'center' : 'flex-start'} />
        {!dataInvoices ? (
          <h1>{translates.loading}</h1>
        ) : (
          <CheckoutPaymentForm
            onSave={onSaveFacturePay}
            onEdit={onSaveChangeTipsFactureService}
            total={dataOrder?.total ?? 0}
            invoices={invoices}
            billingInfo={billingInfo}
          />
        )}
        {Component}
      </Container>
    </>
  );
}
